import { useMemo } from 'react';
import useAuth from './useAuth';
import { Role } from '../domain/Role';

export const useHasRole = (allowedRoles: Role[]) => {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user) {
      return false;
    }
    return allowedRoles.some(allowedRole => user?.roles.includes(allowedRole))
  }, [allowedRoles, user]);
};
